import React from "react";

function AboutHero() {
  return (
    <div className="bg-img-2 h-auto pt-[5rem] lg:min-h-[35rem] min-h-auto lg:px-0 px-3">
      <div className="lg:mt-[5.12rem] mt-[1rem] flex flex-col lg:justify-center lg:items-center lg:text-center font-lexendS">
        <div className="text-ink font-[500] text-[1.75rem] md:text-[2.5rem] lg:text-[3rem] leading-tight lg:leading-[3.375rem] max-w-full lg:max-w-[58rem] w-full">
          Building the Future of Business Payments in Africa
        </div>

        <div className="mt-[1.5rem] text-body text-[1rem] font-[400] leading-[1.5rem] max-w-full lg:max-w-[58rem] w-full">
          A digital platform for businesses, contractors, event organizers, and
          SMEs to simplify financial management. Built for African enterprises.
          Fast, transparent tools for local needs.
        </div>
      </div>
    </div>
  );
}

export default AboutHero;
